class SubscriptionCurrentPlanContainer implements ng.IComponentController {
    constructor() {
    }
}

angular.module('animatronApp.SubscriptionCurrentPlanContainer', [])
    .component('subscriptionCurrentPlanContainer', {
        controller: SubscriptionCurrentPlanContainer,
        templateUrl: require('settings/subscription/containers/subscription-current-plan-container.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/containers/SubscriptionCurrentPlanContainer.ts